import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, eyebrow, children, lastUpdated }) {
  return (
    <main
      data-testid={`legal-page-${title.toLowerCase()}`}
      className="bg-[#0A0A0A] text-[#F5F5F5] min-h-screen pt-32 pb-24"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-[#A3A3A3] hover:text-[#D4AF37] transition-colors mb-12"
        >
          <ArrowLeft size={14} strokeWidth={1.5} />
          Zurück zur Startseite
        </Link>

        <p className="overline mb-4">
          <span className="gold-rule mr-4 align-middle" />
          {eyebrow}
        </p>
        <h1
          className="font-display text-white tracking-tight leading-[1.05]"
          style={{ fontSize: "clamp(2.6rem, 6vw, 4.5rem)", fontWeight: 600 }}
        >
          {title}
        </h1>

        {lastUpdated && (
          <p className="mt-6 text-xs tracking-[0.22em] uppercase text-[#A3A3A3]">
            Stand: {lastUpdated}
          </p>
        )}

        <div className="mt-14 space-y-10 font-body text-[#C9C9C9] leading-relaxed text-base">
          {children}
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[#7A7A7A]">
          <p>© {new Date().getFullYear()} Daniel Lopes Music UG (haftungsbeschränkt)</p>
          <div className="flex gap-6">
            <Link to="/impressum" className="hover:text-[#D4AF37]">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-[#D4AF37]">Datenschutz</Link>
          </div>
        </div>
      </div>
    </main>
  );
}

export function Section({ heading, children }) {
  return (
    <section>
      <h2 className="font-display text-2xl md:text-3xl text-white mb-4 leading-tight">
        {heading}
      </h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
